import React, { useEffect, useState } from "react";

import { v4 as uuidv4 } from "uuid";

import { useNavigate } from "react-router-dom";
import {
  Backdrop,
  Button,
  CustomFileInput,
  CustomInput,
  Divider,
  FormFieldSet,
  InfoTimeCardAdv,
  InvoiceSidebar,
  LogoLoader,
  TableAdv,
  PageHeader,
  PageTitle,
  showToast,
  Tag,
  ToolTip,
  useFormHandler,
  InfoCardNewAdv,
} from "../../../../components";
import {
  CreateInvoiceByOptions,
  InvoiceClientOptions,
  InvoiceEmployeesOptions,
  InvoiceFrequencyOptions,
  netTermsOptions,
} from "../../../../assets/data/projectData";
import ViewAwaitingInvoices from "./ViewAwaitingInvoices";
import FromToDateModal from "./Modal/FromToDateModal";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import common from "../../../../utils/common";
import { ENDPOINTS } from "../../../../redux/apiConfig";
import axiosRequest from "../../../../redux/slices/universal/axiosService";
import { useDispatch } from "react-redux";
import { filterEmptyValues } from "../../../../utils/filterEmptyValues";
import { uploadStart } from "../../../../redux/slices/universal/fileUploadSlice";
import { addInvoicesStart } from "../../../../redux/slices/invoices/invoicesSlice";
import { fetchLatestUiid } from "../../../../redux/slices/employee/employeeApi";
import ResendModal from "../Modals/ResendModal";
import { fetchPlacements } from "../../../../redux/slices/placements/placementsApi";
import dayjs from "dayjs";
import { dateFormator } from "../../../../utils";
import { formatCurrency } from "../../../../utils/stringUtils";
import { sendEmail } from "../../../../utils/wf/email";
import ProceedInvoice from "./Modal/ProceedInvoice";
const PermenentInvoices = ({ onBack, setViewApprovals }) => {
  const {
    calculateDiscountedTotal,
    validateFormFields,
    generateInvoiceNumber,
    formatDiscountDisplay,
    calculateTotalDiscountInvoice,
    validateDiscounts,
  } = common;
  const dispatch = useDispatch();
  const [moreActionModal, setMoreActionModal] = useState(false);
  const [kpiLoading, setKpiLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isMailLoading, setIsMailLoading] = useState(false);
  const [showfromToDate, setShowfromToDate] = useState(false);
  const [showSideBar, setShowSideBar] = useState(false);
  const [successRes, setSuccessRes] = useState(null);

  const navigate = useNavigate();
  const { userData: loginUserData } = useLoginUser();
  const organizationId = loginUserData?.organizationId.uiid;
  const loginUserUiid = loginUserData?.uiid;
  const org = loginUserData?.organizationId;
  const addr = org?.address || {};
  const contactEmail = org?.contactInformation?.[0]?.email?.primary;
  const formattedAddress = [
    org?.name,
    addr.address1,
    addr.address2,
    addr.city,
    addr.state,
    addr.country,
    addr.zipCode,
    contactEmail,
    org?.website,
  ]
    .filter(Boolean)
    .join("\n");
  const defaultValues = {
    createInvoiceBy: "",
    client: "",
    invoiceFrequency: "",
    fromToDate: "",
    intervals: "",
    employees: "",
    billingAddress: " ",
    fromAddress: formattedAddress,
    netTerms: "",
    invoiceDate: new Date(),
    shippedDate: new Date(),
    dueDate: "",
    location: "",
    class: "",
    invoiceNumber: "",
    pONumber: "",
    includePOAttachment: [],
    contactEmail: [],
    ccEmail: [],
    bccEmail: [],
    consultantName: "",
    discounts: [
      {
        id: uuidv4(),
        ss: "",
        select: 1,
        activity: "",
        type: 1,
        discount: "",
        quantity: 0,
        amount: 0,
        rate: 0,
      },
    ],
    notes: "",
    statementMemo: "",
    includeNotesInInvoice: [],
    // statementMemoFrom: "",
    // statementMemoTo: "",
    statementMemoFromTo: "",
    invoiceCetegoty: "",
    attachment: [],
    payableTo: "",
    additionalInfo: "",
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(defaultValues, {});

  const [tableData, setTableData] = useState([]);
  //
  const [loading, setLoading] = useState(false);
  const [placementsUiid, setPlacementsUiid] = useState([]);
  const [entityType, setEntityType] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [allEmployeeList, setAllEmployeeList] = useState([]);
  const [allEmployeePlacementsList, setAllEmployeePlacementsList] = useState(
    [],
  );
  const [selectedValues, setSelectedValues] = useState([]);
  //new thing
  const [allClientsWithPlacementsList, setAllClientsWithPlacementsList] =
    useState([]);
  const [selectedClientWithPlacements, setSelectedClientWithPlacements] =
    useState({});
  const [allEmployeesWithPlacementsList, setAllEmployeeWIthPlacementsList] =
    useState([]);
  const [selectEmployeePlacement, setSelectEmployeePlacement] = useState({});
  const [selectClientOptions, setSelectClientOptions] = useState([]);
  // / timesheetData
  const [latestUiid, setLatestUiid] = useState();
  //
  const [billingInvoiceAddress, setBillingInvoiceAdress] = useState({});
  ///
  const [isMailSendModal, setISMailSendModal] = useState(false);

  useEffect(() => {
    if (formattedAddress && !formData.fromAddress) {
      setFormData((prev) => ({
        ...prev,
        fromAddress: formattedAddress,
      }));
    }
  }, [formattedAddress, formData.fromAddress, setFormData]);

  const handleRowChange = (rowId, field, value) => {
    const newValue = value?.target?.value ?? value;
    const checkFile =
      field === "attachment"
        ? Array.isArray(value)
          ? value
          : [value] // always wrap single file in array
        : newValue;
    setTableData((prevData) =>
      prevData.map((row) =>
        row.id === rowId ? { ...row, [field]: checkFile || "" } : row,
      ),
    );
  };

  const handleAddRow = () => {
    // if (isEdit) {
    const newRow = {
      id: uuidv4(),
      ss: "",
      activity: "",
      quantity: 0,
      amount: 0,
      rate: 0,
      attachment: [],
      editing: true,
      editable: true,
      delete: true,
    };
    setTableData((prev) => [...prev, newRow]);
    // }
  };

  const handleRemoveRow = (rowId) => {
    setTableData((prev) => {
      const updatedRows = prev.filter((row) => row.id !== rowId);
      return updatedRows.length > 0 ? updatedRows : prev;
    });
  };

  const handleEditRow = (rowId) => {
    setTableData((prevData) =>
      prevData.map((row) =>
        row.id === rowId ? { ...row, editing: !row.editing } : row,
      ),
    );
  };
  const columns = [
    {
      key: "ss",
      label: "Service Summary",
      render: (row) => (
        <div className="min-w-max">
          {row.editing ? (
            <CustomInput
              type="text"
              title=""
              size="xs"
              placeholder="Enter Name"
              value={row.ss || ""}
              onChange={(value) => handleRowChange(row.id, "ss", value)}
            />
          ) : (
            <span>{row.ss}</span>
          )}
        </div>
      ),
    },
    {
      key: "activity",
      label: "Activity",
      render: (row) => (
        <div className="min-w-max">
          {row.editing ? (
            <CustomInput
              type="text"
              placeholder="Enter details"
              title=""
              size="xs"
              value={row?.activity || ""}
              onChange={(value) => handleRowChange(row.id, "activity", value)}
            />
          ) : (
            <span>{row?.activity}</span>
          )}
        </div>
      ),
    },
    {
      key: "quantity",
      label: "Quantity(Hrs/days)",
      render: (row) => (
        <div className="min-w-max">
          {row.editing ? (
            <CustomInput
              type="number"
              title=""
              size="xs"
              placeholder="Enter value"
              value={row.quantity || ""}
              onChange={(value) => handleRowChange(row.id, "quantity", value)}
            />
          ) : (
            <span>{row.quantity}</span>
          )}
        </div>
      ),
    },
    {
      key: "rate",
      label: "Rate",
      render: (row) => (
        <div className="min-w-max">
          {row.editing ? (
            <CustomInput
              type="number"
              title=""
              size="xs"
              placeholder="Enter value"
              value={row.rate || ""}
              onChange={(value) => handleRowChange(row.id, "rate", value)}
            />
          ) : (
            <span>{row.rate}</span>
          )}
        </div>
      ),
    },

    {
      key: "amount",
      label: "Amount",
      render: (row) => (
        <div className="min-w-max">
          {row.editing ? (
            <CustomInput
              type="number"
              title=""
              size="xs"
              placeholder="Enter value"
              value={row.amount || ""}
              onChange={(value) => handleRowChange(row.id, "amount", value)}
            />
          ) : (
            <span>{row.amount}</span>
          )}
        </div>
      ),
    },

    {
      key: "attachment",
      label: "Attachment",
      render: (row) => (
        <div className="min-w-max">
          {row.editing ? (
            <CustomFileInput
              type="file"
              placeholder="choose file"
              title=""
              size="xs"
              value={row?.attachment || []}
              // onChange={(value) => handleRowChange(row.id, "attachment", value)}
              onChange={(file) => handleRowChange(row.id, "attachment", file)}
              key={row.id}
            />
          ) : (
            <span>{row.attachment?.[0]?.name || ""}</span>
          )}
        </div>
      ),
    },

    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2 flex-row min-w-max">
          {row.editable === true && (
            <Button
              type="icon"
              icon={row.editing ? "save" : "edit_square"}
              size="xs"
              variant="text"
              color="black"
              onClick={() => handleEditRow(row.id)}
            />
          )}
          {row.delete === true && (
            <Button
              type="icon"
              icon="delete"
              size="xs"
              variant="text"
              color="black"
              onClick={() => handleRemoveRow(row.id)}
            />
          )}
          <Button
            type="icon"
            icon="more_vert"
            size="xs"
            variant="text"
            color="black"
            onClick={() => setMoreActionModal(!moreActionModal)}
          />
        </div>
      ),
    },
  ];
  const handleAddDiscount = () => {
    handleChange("discounts", [
      ...formData.discounts,
      {
        id: uuidv4(),
        name: "",
        type: formData?.discounts?.[0]?.type,
        value: "",
      },
    ]);
  };

  const handleRemoveDiscount = (id) => {
    if (formData.discounts.length > 1) {
      handleChange(
        "discounts",
        formData.discounts.filter((item) => item.id !== id),
      );
    }
  };

  const handleDiscountFieldChange = (id, field, value) => {
    handleChange(
      "discounts",
      formData.discounts.map((item) =>
        item.id === id ? { ...item, [field]: value } : item,
      ),
    );
  };
  const handleDiscountTypeChange = (field, value) => {
    const formDiscount = formData?.discounts || [];
    const updatedDiscounts = formDiscount.map((data) => ({
      ...data,
      [field]: value, // Update the specific field for all discounts
    }));
    setFormData({
      ...formData,
      discounts: updatedDiscounts,
    });
  };
  const lastPayment =
    selectEmployeePlacement?.placements?.[0]?.payments?.at(-1);
  const billRate = lastPayment?.billRate?.rate;
  const tableAmountTotal = tableData.reduce(
    (sum, entry) => sum + Number(entry.amount || 0),
    0,
  );

  const totalDue = tableAmountTotal;
  const calculatedTotal =
    typeof tableAmountTotal === "number" && typeof billRate === "number"
      ? Number((tableAmountTotal * billRate).toFixed(2))
      : 0;
  const frequencyNumber =
    selectEmployeePlacement?.placements?.[0]?.invoices?.frequency;
  const handleFormAction = async (status) => {
    try {
      setLoading(true);

      // ✅ Construct invoice object
      // Validate discounts before proceeding
      const discountErrors = validateDiscounts(formData?.discounts);
      if (discountErrors.length > 0) {
        showToast(discountErrors.join("\n"), "error", 3000);
        return;
      }
      const createInvoice = {
        clientId: selectEmployeePlacement?.clientId,
        invoiceCreatedBy: formData?.createInvoiceBy, // corrected key
        invoiceNum: formData?.invoiceNumber,
        // syncToQb: true,
        poNum: formData?.pONumber,
        type: 2,
        frequency: formData?.intervals,
        frequencyPeriod: {
          from: formData?.fromToDate?.from,
          till: formData?.fromToDate?.to,
        },
        status: status,
        inclPOEmail: !!formData?.includePOAttachment?.[0],
        employeeId: selectEmployeePlacement?.uiid,
        jobId: selectEmployeePlacement?.placements?.[0]?.uiid,
        address: {
          billing: billingInvoiceAddress,
          from: {
            address1: addr?.address1 || "",
            address2: addr?.address2 || "",
            city: addr?.city || "",
            state: addr?.state || "",
            zipCode: addr?.zipCode || "",
            country: addr?.country || "",
            email: contactEmail || "",
            website: org?.website || "",
          },
        },
        netTerms: formData?.netTerms?.value ?? formData?.netTerms,
        invoiceDate: formData?.invoiceDate,
        shippedDate: formData?.shippedDate,
        dueDate: formData?.dueDate,
        amounts: {
          invoiced: calculateDiscountedTotal(
            tableAmountTotal,
            formData?.discounts,
          ),
          due: totalDue,
          // due, received can be added here
        },
        recipients: {
          to: formData?.contactEmail,
          cc: formData?.ccEmail,
          bcc: formData?.bccEmail,
        },
        serviceSummary: tableData,
        finalBill: {
          subTotal: tableAmountTotal,
          discounts: formData?.discounts,
        },
        notes: formData?.notes,
        inclNotesPdf: !!formData?.includeNotesInInvoice?.[0],
        memo: formData?.statementMemo,
        memoPeriod: {
          from: formData?.statementMemoFromTo?.from,
          to: formData?.statementMemoFromTo?.to,
        },
        consultantName: formData?.consultantName,
        additionalInfo: formData?.additionalInfo,
        addedBy: loginUserUiid,
      };
      // ✅ Clean data
      const submissionData = filterEmptyValues(createInvoice);
      // ✅ Filter attachments
      const cleanAttachments = Array.isArray(tableData)
        ? tableData.filter(
            (att) => Array.isArray(att.attachment) && att.attachment.length > 0,
          )
        : [];
      const cleanAttachmentsFiles = cleanAttachments.flatMap((doc) =>
        doc.attachment.map((file) => {
          file.id = doc.id; // add or overwrite id property
          return file; // return updated file object
        }),
      );
      // ✅ Dispatch based on whether there are attachments
      if (cleanAttachmentsFiles.length > 0) {
        dispatch(
          uploadStart({
            uploadType: "multiple",
            field: "doc",
            entity: "invoices",
            uiid: latestUiid,
            category: "ServiceSummaryDocuments",
            coll: "Invoice",
            doc: cleanAttachmentsFiles,
            onSuccess: (fileData) => {
              const updatedSubmissionData = {
                ...submissionData,
                serviceSummary: submissionData.serviceSummary?.map((data) => {
                  const matchedFile = fileData.find(
                    (f) => f?.fileRefId === data.id && f.key,
                  );
                  return {
                    ...data,
                    attachments: matchedFile ? [matchedFile.key] : [],
                  };
                }),
              };
              dispatch(
                addInvoicesStart({
                  coll: "Invoice",
                  // postActions: ["AddToTimesheet"],
                  payload: updatedSubmissionData,
                  onSuccess: (action) => {
                    setLoading(false);
                    setSuccessRes(action?.data?.data || {});
                    // handle success here
                    if (status === 1) {
                      setIsProceedInvoiceOpen(false);
                      navigate(-1);
                    }
                    if (status === 2) {
                      setISMailSendModal(true);
                    }
                  },
                }),
              );
            },
          }),
        );
      } else {
        dispatch(
          addInvoicesStart({
            coll: "Invoice",
            // postActions: ["AddToTimesheet"],
            payload: submissionData,
            onSuccess: (action) => {
              setLoading(false);
              setSuccessRes(action?.data?.data || {});
              if (status === 1) {
                setIsProceedInvoiceOpen(false);
                navigate(-1);
              }
              if (status === 2) {
                setISMailSendModal(true);
              }
            },
          }),
        );
      }
    } catch (e) {
      console.error(e);
      setLoading(false);
    } finally {
      // setLoading(false);
    }
  };
  const handleSave = () => {
    const isValid = validateFormFields(validateAllFields);
    if (!isValid) {
      showToast("Please ensure all required fields are filled before proceeding", "error", 3000);
      return;
    }
    handleFormAction(1); // Call the handleFormAction with actionType 1 for Save
  };
  const handleSubmit = () => {
    handleFormAction(2); // Call the handleFormAction with actionType 2 for Submit
  };
  const handleSubmitMail = () => {
    const isValid = validateFormFields(validateAllFields);
    if (!isValid) {
      return;
    }
    setISMailSendModal(!isMailSendModal);
  };
  // console.log("formData", formData);

  const showFeilds = () => {
    if (
      formData.createInvoiceBy === 2
      // formData.createInvoiceBy === "Manual"
    ) {
      return !!formData.client;
    } else {
      return !!formData.employees;
    }
  };

  const handleSelectClientNVender = (options, data = [], value) => {
    if (!Array.isArray(data) || !value) {
      setAllClientsWithPlacementsList([]);
      setSelectedClientWithPlacements({});
      return;
    }
    const allClientsData = data.find((item) => item?.uiid === value);
    if (allClientsData && Array.isArray(allClientsData.placements)) {
      setPlacementsUiid(allClientsData.placements);
      setAllClientsWithPlacementsList(options);
      setSelectedClientWithPlacements(allClientsData);
    } else {
      setAllClientsWithPlacementsList([]);
      setSelectedClientWithPlacements({});
    }
  };
  const handleSelectEmployeeNPlacement = async (
    options = [],
    data = [],
    value,
    option,
    type,
  ) => {
    try {
      setKpiLoading(true)
    setEmployeeOptions(options);
    setAllEmployeeList(data);
    const selectedEmployee = data.find(
      (item) => String(item?.uiid) === String(option?.uiid),
    );
    if (!selectedEmployee) {
      setSelectEmployeePlacement(null);
      return;
    }
    const matchingPlacement = selectedClientWithPlacements?.placements?.find(
      (placement) =>
        String(placement?.uiid) === String(option?.placementId) &&
        String(placement?.clientId?.uiid) ===
          String(selectedClientWithPlacements?.uiid) &&
        String(placement?.employeeId) === String(option?.uiid),
    );
    let placementDetails = {};
    if (matchingPlacement) {
      try {
        const response = await fetchPlacements({
          fil: {
            uiid: { type: "NONE", value: matchingPlacement.uiid },
          },
          ret: "apexDates payments invoices",
        });

        if (response.success) {
          console.log("Fetched placement details:", response.data);
          placementDetails = response?.data?.data || {};
        } else {
          console.error("Fetch failed:", response.message || response.error);
        }
      } catch (error) {
        console.error("Error fetching placement:", error);
      }
    }
    const filterData = {
      ...selectedEmployee,
      businessName: selectedClientWithPlacements?.businessName,
      clientId: selectedClientWithPlacements?.uiid,
      placements: matchingPlacement
        ? [{ ...matchingPlacement, ...placementDetails }]
        : [],
    };
    setSelectEmployeePlacement(filterData);
    } catch (error) {
    console.error("Error in handleSelectEmployeeNPlacement:", error);
  } finally {
    setKpiLoading(false);
  }
  };

  const handleSelectEmployeeNClientNPlacement = async (
    options = [],
    data = [],
    value,
    option,
  ) => {
    console.log("----");
    setAllEmployeeWIthPlacementsList(data);
    // Find selected employee
    const selectedEmployee = data.find(
      (item) => String(item?.uiid) === String(option?.uiid),
    );
    if (!selectedEmployee) {
      setSelectEmployeePlacement(null);
      return;
    }
    // Find matching placement
    const matchingPlacement = selectedEmployee?.placements?.find(
      (placement) =>
        String(placement?.uiid) === String(option?.placementId) &&
        String(placement?.clientId?.uiid) === String(option?.clientId) &&
        String(placement?.employeeId) === String(selectedEmployee?.uiid),
    );
    let placementDetails = {};
    console.log("matchingPlacement", matchingPlacement);
    if (matchingPlacement) {
      try {
        const response = await fetchPlacements({
          fil: {
            uiid: { type: "NONE", value: matchingPlacement.uiid },
          },
          ret: "apexDates payments invoices", // fix: 'ref' → 'ret' if you intend to return fields
        });

        if (response.success) {
          console.log("Fetched placement details:", response.data);
          // Adjust depending on API response structure
          placementDetails = response?.data?.data || response?.data || {};
        } else {
          console.error("Fetch failed:", response.message || response.error);
        }
      } catch (error) {
        console.error("Error fetching placement:", error);
      }
    }

    const filterData = {
      ...selectedEmployee,
      businessName: option?.businessName,
      clientId: option?.clientId,
      placements: matchingPlacement
        ? [{ ...matchingPlacement, ...placementDetails }]
        : [],
    };

    setSelectEmployeePlacement(filterData);

    // Debug logs
    console.log("data", data);
    console.log("value", value);
    console.log("option", option);
    console.log("options", options);

    handleChange("client", {
      // label: `${option?.businessName}-${option?.placementId}`,
      label: `${option?.businessName}`,
      value: option?.clientId,
    });
  };
  console.log("selectEmployeePlacement", selectEmployeePlacement);
  console.log("selectEmployeePlacement", selectEmployeePlacement);
  useEffect(() => {
    const prepareData = async () => {
      try {
        setKpiLoading(true);

        const placements = selectEmployeePlacement?.placements?.[0] || {};
        const invoices = placements?.invoices || {};
        const payments = placements?.payments?.[0] || {};

        if (invoices) {
          if (invoices?.cc) {
            handleChange("ccEmail", invoices.cc || []);
          }

          if (invoices?.additionalInfo) {
            handleChange("additionalInfo", invoices.additionalInfo || "");
          }

          if (payments) {
            handleChange("pONumber", payments?.poNum);
          }

          handleChange("consultantName", selectEmployeePlacement?.firstName);

          const serviceSummary = {
            id: uuidv4(),
            ss: selectEmployeePlacement?.firstName,
            rate: 1,
            amount:
              typeof payments?.commission === "number"
                ? payments.commission
                : (payments?.commission?.amount ??
                  (payments?.commission?.type === 1
                    ? payments?.commission?.value
                    : Number(payments?.annualPay || 0) *
                      (Number(payments?.commission?.value || 0) / 100))),
            delete: false,
            editable: true,
          };

          setTableData([serviceSummary]);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setKpiLoading(false);
      }
    };

    if (selectEmployeePlacement) {
      prepareData();
    }
  }, [selectEmployeePlacement, formData?.netTerms]);

  useEffect(() => {
    const fetchEntityDetails = async () => {
      try {
        const placements = selectEmployeePlacement?.placements || [];
        const clientUiid = selectEmployeePlacement?.clientId;
        // Skip if either is falsy (null, undefined, empty string, etc.)
        if (!clientUiid) return;
        const url = ENDPOINTS.CLIENTS.GET_BY_UIID;
        if (!url) return;
        const response = await axiosRequest({
          method: "GET",
          url,
          params: {
            coll: "Client",
            fil: JSON.stringify({ uiid: { type: "NONE", value: clientUiid } }),
            cache: false,
            ret: "generalInfo roleContacts businessName",
          },
        });
        const locations = response?.data?.data?.generalInfo?.locations || [];
        const roleContacts = response?.data?.data?.roleContacts || [];
        if (response?.success) {
          const netTerms =
            response?.data?.data?.generalInfo?.placementDetails?.recurring
              ?.netTerms;
          if (netTerms) {
            handleChange("netTerms", { label: netTerms, value: netTerms });
          }
          console.log("locations", locations);
          const defaultInvoiceLocation = locations.find(
            (loc) => loc.isDefaultInvoice === true,
          );
          if (defaultInvoiceLocation) {
            const formattedAddress = [
              response?.data?.data?.businessName,
              defaultInvoiceLocation.address1,
              defaultInvoiceLocation.address2,
              defaultInvoiceLocation.city,
              defaultInvoiceLocation.state,
              defaultInvoiceLocation.country,
              defaultInvoiceLocation.zipCode,
            ]
              .filter(Boolean)
              .join("\n");
            setBillingInvoiceAdress(defaultInvoiceLocation);
            handleChange("billingAddress", formattedAddress);
          }
          if (roleContacts.length > 0) {
            const filterEmails = roleContacts
              .filter((data) => data.email && data.email.length > 0)
              .flatMap((data) => data.email);
            handleChange("contactEmail", filterEmails);
          }
        }
      } catch (error) {
        console.error("Error fetching entity details:", error);
        // You could also optionally log to an error monitoring service here
      }
    };

    fetchEntityDetails();
  }, [formData.client, formData?.employees]);
  useEffect(() => {
    if (formData.netTerms && formData.invoiceDate) {
      const number = String(
        formData?.netTerms?.value ?? formData?.netTerms ?? "0",
      ).match(/\d+/);
      const extractedNumber = number ? parseInt(number[0], 10) : null;
      if (extractedNumber !== null) {
        // Convert invoiceDate to Date object
        const invoiceDate = new Date(formData?.invoiceDate);
        // Add the extracted number of days to the invoiceDate
        invoiceDate.setDate(invoiceDate.getDate() + extractedNumber);
        // Format the dueDate (YYYY-MM-DD format)
        const dueDate = invoiceDate.toISOString().split("T")[0]; // "YYYY-MM-DD"
        // Update the dueDate
        handleChange("dueDate", dueDate);
      }
    }
  }, [formData.netTerms, formData.invoiceDate]);
  useEffect(() => {
    const handleInvoiceGeneration = async () => {
      if (
        formData?.client &&
        formData?.employees &&
        formData?.createInvoiceBy &&
        selectEmployeePlacement
      ) {
        const newInvoiceNumber = await generateInvoiceNumber(latestUiid);
        handleChange("invoiceNumber", newInvoiceNumber);
      }
    };
    handleInvoiceGeneration();
  }, [
    formData?.client,
    formData?.employees,
    formData?.createInvoiceBy,
    selectEmployeePlacement,
    selectClientOptions,
  ]);

  useEffect(() => {
    const fetchLatestUiidData = async () => {
      try {
        const response = await fetchLatestUiid("invoices");
        const count = response?.data?.data?.count;
        if (typeof count === "number") {
          setLatestUiid(count + 1);
        } else {
          setLatestUiid(1);
        }
      } catch (error) {
        // showToast("Error fetching latest UIID", "error", 5000);
        setLatestUiid(1);
      }
    };

    fetchLatestUiidData();
  }, []);

  const handleSendMail = async (mailDetails) => {
    try {
      setIsMailLoading(true);
      if (!mailDetails?.emails?.selectedUsers?.length) {
        showToast("Please select at least one recipient to send the email.", "error", 5000);
        setIsMailLoading(false);
        return;
      }
      const actions = [
        ...(mailDetails?.attachments?.includes(1) ? [{
          type: "INVOICE_PDF",
          params: {
           invoiceId: successRes?.invoiceId || null,
          },
        }] : []),
      ]
      const res = await sendEmail({
        to: mailDetails?.emails?.selectedUsers?.map((data) => data.email) || [],
        cc: mailDetails?.emails.ccUsers?.map((data) => data.email) || [],
        bcc: mailDetails?.emails.bccUsers?.map((data) => data.email) || [],
        subject: mailDetails.subject,
        html: mailDetails.body,
      }, actions);
      if(res?.success){
        showToast("Email has been sent successfully", "success", 5000);
        setISMailSendModal(!isMailSendModal);
      }
      console.log("res from handleSendMail in placement invoice", res);
    } catch (error) {
      showToast("An error occured while sending the email", "error", 5000);
      console.error("Error sending email:", error);
    } finally {
      setIsMailLoading(false);
      //compulasory to close mail modal and navigate after mail sent
      setISMailSendModal(false);
      navigate("/invoices");
    }
  };

  //////////////
  const [isProceedInvoiceOpen, setIsProceedInvoiceOpen] = useState(false);
  //////////////

  return (
    <div className="flex-1 flex flex-col lg:flex-row gap-2 h-full overflow-hidden">
      <div
        className={`border-[1px] border-neutrals-50 rounded p-3 mt-2 overflow-auto w-full`}
      >
        <PageHeader
          Section={
            <div className="flex gap-3 mt-2">
              <PageTitle title={"Create Invoice"} tag="p" size={"sm"} />
              <Tag
                title="Tektree"
                variant="outlined"
                className=" !text-neutrals !py-1.5"
              />
            </div>
          }
          RightSection={
            <div className="flex gap-3 mt-2">
              <Button
                size="sm"
                title={"Back"}
                icon={"arrow_left_alt"}
                onClick={() => navigate("/invoices")}
              />
              <Button
                size="sm"
                title={"View Awaiting Invoices"}
                onClick={() => {
                  setViewApprovals(true);
                }}
              />
            </div>
          }
        />

        <div className="flex flex-col-reverse lg:flex-row mt-3 gap-1 xl:gap-3">
          <div
            className={`grid ${
              showSideBar
                ? "grid-cols-2 xl:grid-cols-3"
                : "grid-cols-2 xl:grid-cols-3"
            } gap-x-6 gap-y-4 mt-3 flex-1`}
          >
            {/* Create Invoice By */}
            <FormFieldSet
              type="select"
              title="Create Invoice By"
              placeholder="Select Create Invoice By"
              value={formData.createInvoiceBy}
              onChange={(value) => {
                handleChange("createInvoiceBy", value);
                handleChange("client", "");
                handleChange("employees", "");
                handleChange("invoiceFrequency", "");
                setFormData({
                  ...defaultValues,
                  createInvoiceBy: value,
                });
                setTableData([]);
                handleChange("fromToDate", "");
                handleChange("intervals", "");
                setShowSideBar(false);
                setAllClientsWithPlacementsList([]);
                setSelectedClientWithPlacements({});
              }}
              error={errors.createInvoiceBy}
              options={CreateInvoiceByOptions}
            />

            {/* Conditional field order */}
            {[1, 3].includes(formData.createInvoiceBy) ? (
              <>
                {/* Client First */}
                <FormFieldSet
                  type="clientsWithPlacements"
                  title="Client"
                  placeholder="Select Client"
                  value={formData.client}
                  onChange={(value) => {
                    handleChange("employees", "");
                    setFormData({
                      ...defaultValues,
                      createInvoiceBy: formData?.createInvoiceBy,
                    });
                    handleChange("client", value);
                    setTableData([]);
                  }}
                  error={errors.client}
                  filters={{
                    useAggregate: true,
                    type: 2,
                  }}
                  showSearch
                  disabled={!formData.createInvoiceBy}
                  onSelectItem={(options, data, value) =>
                    handleSelectClientNVender(options, data, value)
                  }
                />

                {/* Employees Last */}
                <FormFieldSet
                  type={
                    selectedClientWithPlacements ? "allEmployees" : "select"
                  }
                  title="Employees"
                  placeholder="Select Employees"
                  value={formData.employees}
                  onChange={(value) => {
                    handleChange("employees", value);
                  }}
                  error={errors.employees}
                  // options={InvoiceEmployeesOptions}
                  // showSearch
                  disabled={!formData.createInvoiceBy}
                  filters={{
                    ret: "firstName middleName lastName email.primary uiid",
                    fil: {
                      uiid: {
                        type: "IN",
                        value: [
                          ...new Set(
                            (
                              selectedClientWithPlacements?.placements || []
                            ).map((p) => p.employeeId),
                          ),
                        ],
                      },
                    },
                    selectedClientWithPlacements:
                      selectedClientWithPlacements || {},
                  }}
                  onSelectItem={(options, data, value, option) =>
                    handleSelectEmployeeNPlacement(
                      options,
                      data,
                      value,
                      option,
                      "client",
                    )
                  }
                />
              </>
            ) : (
              <>
                {/* Employees First */}
                <FormFieldSet
                  type="employeeWithPlacement"
                  title="Employees"
                  placeholder="Select Employees"
                  value={formData.employees}
                  onChange={(value) => {
                    handleChange("client", "");
                    setFormData({
                      ...defaultValues,
                      createInvoiceBy: formData?.createInvoiceBy,
                    });
                    handleChange("employees", value);
                    setTableData([]);
                  }}
                  error={errors.employees}
                  options={InvoiceEmployeesOptions}
                  showSearch
                  disabled={!formData.createInvoiceBy}
                  filters={{
                    ret: "firstName middleName lastName email.primary uiid placements",
                    useAggregate: true,
                    type: 2,
                  }}
                  onSelectItem={(options, data, value, option) => {
                    handleSelectEmployeeNClientNPlacement(
                      options,
                      data,
                      value,
                      option,
                    );
                  }}
                />
                {/* Client Last */}
                <FormFieldSet
                  type="select"
                  title="Client"
                  placeholder="Select Client"
                  value={formData.client}
                  uiid={1}
                  // onChange={(value) => handleSelectClientPlacement(value)}
                  error={errors.client}
                  // showButton
                  showSearch
                  options={[]}
                  // options={selectClientOptions}
                  disabled={!formData.createInvoiceBy}
                />
              </>
            )}
          </div>

          <div className="flex justify-end">
            <div className="ml-8  min-w-60">
              <InfoCardNewAdv
                layout="option12"
                title="Total Due"
                value={totalDue}
                valueConfig={{ className: "text-[24px]!", decimals: 2 }}
                suffixConfig={{
                  className: "mt-1 justify-end! item-end! font-normal!",
                }}
                suffix="USD"
                isLoading={kpiLoading}
              />
            </div>
          </div>
        </div>

        {showFeilds() && (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-6 mt-4 ">
              <FormFieldSet
                type="textArea"
                title={"Billing Address"}
                placeholder="Enter Billing Address"
                value={formData.billingAddress}
                onChange={(value) => handleChange("billingAddress", value)}
                error={errors.billingAddress}
                rows={5}
                disabled={true}
              />
              <FormFieldSet
                type="textArea"
                title={"From Address"}
                placeholder="Enter From Address"
                value={formData.fromAddress}
                onChange={(value) => handleChange("fromAddress", value)}
                error={errors.fromAddress}
                rows={5}
                disabled={true}
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-6 max-w-7xl mt-4">
              <FormFieldSet
                // type="netTerm"
                type="select"
                title={"Net Terms"}
                placeholder="Select Net Terms"
                value={formData.netTerms}
                onChange={(value) => handleChange("netTerms", value)}
                error={errors.netTerms}
                options={netTermsOptions}
                // showButton
                showSearch
              />
              <FormFieldSet
                type="datepicker"
                title={"Invoice Date"}
                placeholder="Select Invoice Date"
                value={formData.invoiceDate}
                onChange={(value) => handleChange("invoiceDate", value)}
                error={errors.invoiceDate}
                showDropdown={false}
              />
              <FormFieldSet
                type="datepicker"
                title={"Shipped Date"}
                placeholder="Select Shipped Date"
                value={formData.shippedDate}
                onChange={(value) => handleChange("shippedDate", value)}
                error={errors.shippedDate}
                showDropdown={false}
              />
              <FormFieldSet
                type="datepicker"
                title={"Due Date"}
                placeholder="Select Due Date"
                value={formData.dueDate}
                onChange={(value) => handleChange("dueDate", value)}
                error={errors.dueDate}
                showDropdown={false}
              />
              {/* <FormFieldSet
                type="text"
                title={"Location"}
                placeholder="Enter Location"
                value={formData.location}
                onChange={(value) => handleChange("location", value)}
                error={errors.location}
              />
              <FormFieldSet
                type="text"
                title={"Class"}
                placeholder="Enter Class"
                value={formData.class}
                onChange={(value) => handleChange("class", value)}
                error={errors.class}
              /> */}
              <FormFieldSet
                type="text"
                title={"Invoice Number (Auto-Generated)"}
                placeholder="Enter Invoice Number"
                value={formData.invoiceNumber}
                onChange={(value) => handleChange("invoiceNumber", value)}
                error={errors.invoiceNumber}
                disabled={true}
              />
              <FormFieldSet
                type="text"
                title={"PO Number"}
                placeholder="Enter PO Number"
                value={formData.pONumber}
                onChange={(value) => handleChange("pONumber", value)}
                error={errors.pONumber}
              />
              <FormFieldSet
                type="checkbox"
                size={"md"}
                title=""
                options={[
                  {
                    label: "Include PO Attachment in Email",
                    value: true,
                  },
                ]}
                values={formData.includePOAttachment || []}
                onChange={(value) => handleChange("includePOAttachment", value)}
                multiple
                error={errors.includePOAttachment}
              />
            </div>
            <div className="mt-6">
              <p>Invoice Attachments</p>
              <Divider />
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 max-w-7xl gap-x-6 gap-y-6 mt-6">
                <FormFieldSet
                  type={"email"}
                  title={
                    <ToolTip
                      size="sm"
                      description={"Please type and enter"}
                      color="primary"
                    >
                      <span className="mr-1">Contact Email(s)</span>
                    </ToolTip>
                  }
                  value={formData.contactEmail}
                  onChange={(value) => handleChange("contactEmail", value)}
                  error={errors.contactEmail}
                  multiple
                />
                <FormFieldSet
                  type={"email"}
                  title={
                    <ToolTip
                      size="sm"
                      description={"Please type and enter"}
                      color="primary"
                    >
                      <span className="mr-1">CC Email(s)</span>
                    </ToolTip>
                  }
                  value={formData.ccEmail}
                  onChange={(value) => handleChange("ccEmail", value)}
                  error={errors.ccEmail}
                  multiple
                />

                <FormFieldSet
                  type={"email"}
                  title={
                    <ToolTip
                      size="sm"
                      description={"Please type and enter"}
                      color="primary"
                    >
                      <span className="mr-1">BCC Email(s)</span>
                    </ToolTip>
                  }
                  placeholder="Enter Email"
                  value={formData.bccEmail}
                  onChange={(value) => handleChange("bccEmail", value)}
                  error={errors.bccEmail}
                  multiple
                />
                <FormFieldSet
                  type="text"
                  title={"Consultant Name"}
                  value={formData.consultantName}
                  onChange={(value) => handleChange("consultantName", value)}
                  error={errors.consultantName}
                />
              </div>
            </div>
          </>
        )}
        <div>
          <div className="flex justify-between mt-6 mb-1 items-end">
            <p>Service Summary</p>
            <Button
              title="Add"
              color="black"
              icon="add"
              onClick={handleAddRow}
            />
          </div>
          <Divider />
          <div className="mt-3">
            <TableAdv
              tableId={`invoices_addinvoices_peramanentinvoice`}
              rows={tableData}
              columns={columns}
              hideToolBar
              showSlNo
            />
          </div>
        </div>
        <div className="mt-4">
          <p>Notes & Total </p>
          <Divider />
        </div>
        <div className=" mt-2">
          <div className="flex flex-col items-end gap-2">
            <div className="flex items-center gap-2">
              Subtotal:
              <div className="bg-black text-white pl-3 pr-2 py-2">
                {tableAmountTotal} USD
              </div>
            </div>
            <div className="flex flex-col gap-4 items-start w-full">
              {formData.discounts.map((discount, index) => (
                <div
                  key={discount.id}
                  className="grid grid-cols-[repeat(3,1fr)] items-start lg:grid-cols-[repeat(3,1fr)] xl:grid-cols-[repeat(4,1fr)_1.2fr] gap-6 mt-3 w-full"
                >
                  <div className="flex-1">
                    <FormFieldSet
                      type="text"
                      noTitle={true}
                      value={discount.name}
                      placeholder="Name"
                      onChange={(value) =>
                        handleDiscountFieldChange(discount.id, "name", value)
                      }
                    />
                  </div>
                  <div className="w-full lg:flex-1">
                    <FormFieldSet
                      type="select"
                      noTitle={true}
                      value={discount.type}
                      placeholder="Select"
                      onChange={(value) =>
                        handleDiscountTypeChange("type", value)
                      }
                      disabled={index !== 0}
                      options={[
                        { label: "Percentage", value: 1 },
                        { label: "value", value: 2 },
                      ]}
                    />
                  </div>
                  <div className="w-full lg:flex-1">
                    <FormFieldSet
                      type="text"
                      title=""
                      placeholder="Discount"
                      noTitle={true}
                      value={discount.value}
                      onChange={(value) =>
                        handleDiscountFieldChange(discount.id, "value", value)
                      }
                    />
                  </div>
                  <div className="w-full lg:flex-1">
                    <FormFieldSet
                      type="text"
                      title=""
                      placeholder="comment"
                      noTitle={true}
                      value={discount.comment}
                      onChange={(value) =>
                        handleDiscountFieldChange(discount.id, "comment", value)
                      }
                    />
                  </div>
                  <div className="mt-3 flex gap-2 items-center">
                    <Button
                      type="icon"
                      icon="add"
                      size="xs"
                      color="black"
                      onClick={handleAddDiscount}
                    />
                    <Button
                      type="icon"
                      icon="remove"
                      size="xs"
                      color="danger"
                      onClick={() => handleRemoveDiscount(discount.id)}
                    />
                    <div className="text-gray-600">
                      {formatDiscountDisplay(discount, tableAmountTotal)} USD
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex justify-end gap-2 mt-3">
              discount Total:
              <div>
                {" "}
                {calculateTotalDiscountInvoice(
                  formData?.discounts,
                  tableAmountTotal,
                )}
                USD
              </div>
            </div>
            {/* <div className="min-w-72 "> */}
            <div className="min-w-45">
              <Divider />
              <div className="flex justify-end ">
                <p>
                  Grand Total{" "}
                  <span className="ml-7">
                    {calculateDiscountedTotal(
                      tableAmountTotal,
                      formData.discounts,
                    )}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 max-w-7xl flex-1 mt-4">
          <FormFieldSet
            type="textArea"
            placeholder="Enter Notes"
            title="Notes"
            value={formData.notes}
            onChange={(value) => handleChange("notes", value)}
            error={errors.notes}
          />
          <FormFieldSet
            type="text"
            placeholder="Enter Statement Memo"
            title="Statement Memo"
            value={formData.statementMemo}
            onChange={(value) => handleChange("statementMemo", value)}
            error={errors.statementMemo}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 mt-2">
          <FormFieldSet
            type="checkbox"
            size={"md"}
            title={""}
            options={[
              {
                label: "Include Notes in invoice PDF",
                value: true,
              },
            ]}
            values={formData.includeNotesInInvoice || []}
            onChange={(value) => handleChange("includeNotesInInvoice", value)}
            multiple
            error={errors.includeNotesInInvoice}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-x-6 gap-y-8 mt-6 max-w-7xl ">
          <FormFieldSet
            type="datepickerRange"
            title=" Statement Memo Period From and To Date"
            placeholder="Select Statement Memo Period From and To Date"
            value={formData.statementMemoFromTo}
            onChange={(val) => handleChange("statementMemoFromTo", val)}
            error={errors.statementMemoFromTo}
            showDropdown={false}
          />
          {/* <FormFieldSet
            type="select"
            title="Invoice Category"
            placeholder="Select Invoice Category"
            value={formData.invoiceCetegoty}
            onChange={(value) => handleChange("invoiceCetegoty", value)}
            error={errors.invoiceCetegoty}
          />
          <FormFieldSet
            type="file"
            title="Attachment"
            placeholder="Choose File"
            value={formData.attachment}
            onChange={(value) => handleChange("attachment", value)}
            error={errors.attachment}
          />
          <FormFieldSet
            type="textArea"
            title="Payable To"
            value={formData.payableTo}
            onChange={(value) => handleChange("payableTo", value)}
            error={errors.payableTo}
          /> */}
        </div>
        <div className="mt-4">
          <p>Additional Info </p>
          <Divider />
          <div className="border-[1px] border-neutrals-50 rounded p-3 min-h-[250px]">
            <FormFieldSet
              type="textArea"
              placeholder="Enter Additional Info"
              title=""
              value={formData.additionalInfo}
              onChange={(value) => handleChange("additionalInfo", value)}
              error={errors.additionalInfo}
            />
          </div>
        </div>
        <div className="flex justify-end gap-3 my-6">
          <Button title={"Cancel"} variant="outlined" onClick={onBack} />
          {/* <Button title={"Save"} onClick={() => handleSave()} /> */}
          {/* <Button title={"Submit"} onClick={() => handleSubmitMail()} /> */}
          <Button
            title={"Proceed "}
            onClick={() => setIsProceedInvoiceOpen(true)}
          />
        </div>
      </div>
      {isMailSendModal && (
        <ResendModal
          open={isMailSendModal}
          onClose={() => {
            setISMailSendModal(!isMailSendModal);
            // navigate(-1);
            navigate("/invoices?invoices=all-invoices");
          }}
          toEmail={formData?.contactEmail}
          ccEmail={formData?.ccEmail}
          bccEmail={formData?.bccEmail}
          data={{
            orgLogo: loginUserData?.organizationId?.logo?.company || "",
            orgName: loginUserData?.organizationId?.name || "",
            invoiceNum: formData?.invoiceNumber || "",
            client: formData?.client?.label || "",
            // dueDate: dayjs(formData?.dueDate).format("MM/DD/YYYY") || "",
            // invoiceDate: dateFormator(formData?.invoiceDate),
            dueDate: dayjs(formData?.dueDate).format("MM/DD/YYYY") || "",
            invoiceDate:
              dayjs(formData?.invoiceDate).format("MM/DD/YYYY") || "",
            amount:
              formatCurrency(
                calculateDiscountedTotal(tableAmountTotal, formData?.discounts),
              ) || "",
            invoiceUrl:
              import.meta.env.VITE_APP_ENV === "production"
                ? "https://tektree.kultworks.ai/invoices#all-invoices"
                : "https://staging.kultworks.ai/invoices#all-invoices",
          }}
          templateName="invoice_created"
          emailSubject={"Invoice Update..."}
          handleSave={handleSendMail}
          isMailSaving={isMailLoading}
          timesheetDisable={true}
        />
      )}
      {isProceedInvoiceOpen && (
        <ProceedInvoice
          isOpen={isProceedInvoiceOpen}
          data={formData}
          totalDue={totalDue}
          onClose={() => setIsProceedInvoiceOpen(false)}
          onSave={() => handleSave()}
          onSubmit={() => handleSubmit()}
          mappedRows={tableData}
          columns={columns}
          tableSubTotal={tableAmountTotal}
        />
      )}
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default PermenentInvoices;
